import React from 'react';
import Carousel from './Carousel';
import AboutUsHome from '../pages/AboutUsHome';
import Amenities from '../pages/Amenities';
import RoomsSection from '../pages/RoomsSection';
import ServiceSection from '../pages/ServiceSection';
// import ServiceSectionTwo from '../pages/ServiceSectionTwo';
import CtaSection from '../pages/CtaSection';
import TestimonialsSection from '../pages/TestimonialsSection';
import FunfactSection from '../pages/FunfactSection';
import NewsSection from '../pages/NewsSection';


const Hero = () => {
  return (
    <div>
<Carousel/>

<div className='dark_bg'>
<AboutUsHome/>
<Amenities/>
<RoomsSection/>
<ServiceSection/>
{/* <ServiceSectionTwo/> */}
<CtaSection/>
<TestimonialsSection/>
<FunfactSection/>
<NewsSection/>
</div>

    </div>
  );
};

export default Hero;
